import { Directive, ElementRef, Renderer2 } from "@angular/core";

@Directive({
    selector: "[hZoomCursor]",
    standalone: true,
})
export class ZoomCursorDirective {
    constructor(element: ElementRef, renderer: Renderer2) {
        renderer.setStyle(
            element.nativeElement,
            "cursor",
            this.getZoomCursor(),
        );
    }

    /**
     * Encode and return svg for cursor icon on image hover
     */
    public getZoomCursor(): string {
        const zoomCursor: string = [
            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="40px" viewBox="0 0 40 40">',
            '<g fill="none" fill-rule="evenodd" stroke="#333" stroke-width="2">',
            '<circle cx="20.5" cy="20.5" r="10.5" fill="transparent"/>',
            '<g stroke-linecap="round">',
            '<path d="M15 20.5h11M20.5 15v11"/>',
            "</g>",
            "</g>",
            "</svg>",
        ].join("");
        return `url("data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
            zoomCursor,
        )}") 20 20, pointer`;
    }
}
